import React from "react";

export const About = (props) => {
    return (
        <div class="jumbotron jumbotron-fluid">
            <div class="container">
                <h1 class="display-4">React приложение</h1>
                <p class="lead">Версия приложения <b>1.0.0</b></p>
            </div>
        </div>
    )
}